import { alpha, Box, useTheme } from '@mui/material';

interface IOverlayProps {
  isVisible: boolean;
}

/**
 * Компонент затемнения фона
 * @param root0 Пропсы
 * @param root0.isVisible Видимость затемнения
 */
export const Overlay = ({ isVisible }: IOverlayProps) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: alpha(theme.palette.common.black, 0.5),
        zIndex: 1000,
        opacity: isVisible ? 1 : 0,
        visibility: isVisible ? 'visible' : 'hidden',
        transition: 'opacity 0.3s ease-in-out, visibility 0.3s ease-in-out',
        cursor: 'pointer'
      }}
    />
  );
};
